import { render } from "./ServiceJobGroupView.vue?vue&type=template&id=16f52f2c&scoped=true&ts=true"
import script from "./ServiceJobGroupView.vue?vue&type=script&lang=ts"
export * from "./ServiceJobGroupView.vue?vue&type=script&lang=ts"

import "./ServiceJobGroupView.vue?vue&type=style&index=0&id=16f52f2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f52f2c"]])

export default __exports__